import {
	PUB_SUB_EVENTS,
	publish,
	qsaRequired,
	qsRequired,
} from '@/scripts/core/global'
import { UcoastEl } from '@/scripts/core/UcoastEl'
import { type DynamicQuizStub } from '@/scripts/interactive-defer/dynamic-quiz-stub'
import {
	addItemsToCart,
	getDOMCartSectionApiIds,
	renderResponseToCartDrawer,
} from '@/scripts/core/cart-functions'

export class DynamicQuizResult extends UcoastEl {
	static htmlSelector = 'dynamic-quiz-result'
	titleEl: HTMLElement
	backButtons: NodeListOf<HTMLButtonElement>
	variantIds: number[]
	submitButton: HTMLButtonElement

	constructor() {
		super()
		this.titleEl = qsRequired('[data-title]', this)
		this.backButtons = qsaRequired('[data-quiz-back]', this)
		this.onBackClick = this.onBackClick.bind(this)
		this.variantIds = this.getVariantIds()
		this.submitButton = qsRequired('[data-submit]', this)
	}

	override connectedCallback() {
		super.connectedCallback()
		this.titleEl.innerHTML =
			qsRequired<DynamicQuizStub>('dynamic-quiz-stub').titleText ?? ''
		this.backButtons.forEach((button) => {
			button.addEventListener('click', this.onBackClick)
		})
		this.submitButton.addEventListener('click', this.onAddToCart.bind(this))
	}
	async onBackClick() {
		const stub = qsRequired<DynamicQuizStub>('dynamic-quiz-stub')
		await stub.getQuizContent()
		void window.Ucoast.mediaManager.loadAllInContainer(stub)
	}
	getVariantIds(): number[] {
		const textContent = qsRequired<HTMLScriptElement>(
			'[type="application/json"][data-variant-ids]',
			this
		).textContent
		if (!textContent) throw new Error('Variant data not found')
		return JSON.parse(textContent).variant_ids
	}
	async onAddToCart(e: Event) {
		e.preventDefault()
		const items = this.variantIds.map((variantId) => ({
			id: variantId,
			quantity: 1,
			properties: {},
		}))
		await addItemsToCart(items, getDOMCartSectionApiIds())
			.then((cart) => {
				if ('status' in cart) {
					return
				}

				this.variantIds.forEach((addedVariantId) => {
					publish(PUB_SUB_EVENTS.cartUpdate, {
						source: 'product-form',
						productVariantId: addedVariantId,
					})
				})

				const quickAddModal =
					qsRequired<DynamicQuizStub>('dynamic-quiz-stub')
				renderResponseToCartDrawer(cart, quickAddModal)
			})
			.catch((e) => {
				console.error(e)
			})
			.finally(() => {})
	}
}
